module.exports = __webpack_public_path__ + "img/Framemanege.42b310b4.png";